<template>
    <div class="FM_withdrawalList">
        <!-- 用户搜索 -->
        <el-card class="box-card" shadow="hover" v-if="level==0">
            <el-form :inline="true" :model="withdrawalForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="withdrawalForm.phone" placeholder="请输入代理商账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="handleSearch(withdrawalForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 用户列表 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="withdrawalTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        width="80"
                ></el-table-column>
                <!-- 所属机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_no"
                        label="代理商编号"
                        width="140"
                ></el-table-column>
                <!-- 所属机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="nickname"
                        label="代理商名称"
                        width="120"
                ></el-table-column>
                <!-- 商户姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="代理商手机号"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                            <p>{{ scope.row.phone | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 商户姓名 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="merchant_number"
                        label="商户编号"
                        width="140"
                ></el-table-column>
                <!-- 商户手机号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="商户名称"
                        width="150"
                >
				</el-table-column>
				<!-- 商户手机号 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="terminal_sn"
				        label="终端号"
				        width="190"
				>
				</el-table-column>
				<!-- 商户手机号 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="remark"
				        label="解绑原因"
				        min-width="120"
				>
				</el-table-column>
				<!-- 商户手机号 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="status"
				        label="当前状态"
				        width="100"
						:formatter="format_status"
				>
				</el-table-column>
				<!-- 商户手机号 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="create_time"
				        label="申请日期"
				        width="150"
				>
				</el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="150"
						v-if="level==0"
                >
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                slot="reference"
                                @click="handledo(scope.row)"
								v-if="scope.row.status==0"
                        >同意</el-button>
						<el-button
						        type="text"
						        size="small"
						        slot="reference"
						        @click="handleundo(scope.row)"
								v-if="scope.row.status==0"
						>拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<!-- 分页部分 -->
			<paginations
			    :currentPage="page.currentPage"
			    :pageSize="page.pageSize"
			    :total="page.total"
			    @watchCurrent="getCurrent"
			    @watchPageSize="getPageSize"
			    style="text-align: center"
			></paginations>
        </el-card>
    </div>
</template>

<script>
	import paginations from '../../components/pagination/paginations';
export default {
    name: "FM_forceUnBindList",
    data() {
        return {
            withdrawalTable: [], //表格
            withdrawalForm: {
                phone: '', //代理账号
                page:'1',
                limit:'10'
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.getData();
    },
    components: {
        paginations,
    },
    methods: {
        handleSearch() {
            // 表单提交
            this.getData();
        },
        getData() { //获取列表
            this.loading = true;
            this.$api.post("terminal/getApplyUnBindInfoList", this.withdrawalForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.page.total = data.total; //总数
                    this.withdrawalTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.withdrawalForm.page = this.page.currentPage;
            this.withdrawalForm.limit = this.page.pageSize;
            this.getData(this.withdrawalForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.withdrawalForm.page = this.page.currentPage;
            this.withdrawalForm.limit = limit;
            this.getData(this.withdrawalForm);
        },
		format_status(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.status) {
				case  1:
					card = '审核通过';
					break;
				case  2:
					card = '审核拒绝';
					break;
				case  3:
					card = '已重新绑定';
					break;
		        default:
		            card = '待审核';
		            break;
		    }
		    return card;
		},
		handledo(data){
			this.$confirm('确认同意?', '提示', {
			    confirmButtonText: '确认',
			    cancelButtonText: '取消',
			    closeOnClickModal: false,
			    type: 'warning',
			    beforeClose: (action, instance, done) => {
			        if (action == 'confirm') {
			            instance.confirmButtonLoading = true;
						data.status=1;
			            this.$api.post('terminal/changeUnBindSn', data, res => {
			                if (res.code == 0) {
			                    this.$message.success(res.msg);
								done();
								instance.confirmButtonLoading = false;
								getData();
			                } else {
			                    this.$message.error(res.msg);
			                    instance.confirmButtonLoading = false;
			                }
			            })
			        } else {
			            done();
			        }
			    }
			}).then(() => {
			}).catch(() => { });
		},
		handleundo(data){
			this.$confirm('确认拒绝?', '提示', {
			    confirmButtonText: '确认',
			    cancelButtonText: '取消',
			    closeOnClickModal: false,
			    type: 'warning',
			    beforeClose: (action, instance, done) => {
			        if (action == 'confirm') {
			            instance.confirmButtonLoading = true;
						data.status=2;
			            this.$api.post('terminal/changeUnBindSn', data, res => {
			                if (res.code == 0) {
			                    this.$message.success(res.msg);
								done();
								instance.confirmButtonLoading = false;
								getData();
		
			                    
			                } else {
			                    this.$message.error(res.msg);
			                    instance.confirmButtonLoading = false;
			                }
			            })
			        } else {
			            done();
			        }
			    }
			}).then(() => {
			}).catch(() => { });
		},
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalList {
  .batchTitle {
    font-size: 12px;
    margin: 20px 0;
    :nth-child(1) {
      font-weight: 700;
      color: #1e1e1e;
    }
  }
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
}
</style>
